// extracted by mini-css-extract-plugin
export default {"banner_text":"Banner_banner_text__c4-pw","bg_img":"Banner_bg_img__bvhEm","bg_color":"Banner_bg_color__QWAKN"};